__turbopack_context__.v({
  "mobileTabSelect": "researchTile-module-scss-module__pZcBHq__mobileTabSelect",
});
